  function newsApp({
    category,
    sort,
    offset,
    limit,
    hasMore,
  }) {

    function debounce(func, wait) {
        let timeout;
        return function (...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), wait);
        };
    }
    return {
        loading:false,
        category: category,
        sort: sort,
        offset:offset,
        limit:limit,
        hasMore:hasMore,
        init() {
            // Debounced fetchEntries to prevent multiple simultaneous calls
            this.debouncedFetchEntries = debounce((replace = false) => {
                this.fetchEntries(replace);
            }, 100); // 100ms delay to catch multiple changes

            // Update URL on category change
            this.$watch('category', value => {
                const url = new URL(window.location);
                if (value) {
                    url.searchParams.set('category', value);
                } else {
                    url.searchParams.delete('category');
                }
                window.history.pushState({}, '', url);
                this.offset = 0;
                this.debouncedFetchEntries(true);
            });

            // Update URL on sort change
            this.$watch('sort', value => {
                const url = new URL(window.location);
                if (value) {
                    url.searchParams.set('sort', value);
                } else {
                    url.searchParams.delete('sort');
                }
                window.history.pushState({}, '', url);
                this.offset = 0;
                this.debouncedFetchEntries(true);
            });
        },
        setCategory(slug) {
            this.category = slug;
        },
        async loadMore() {
            await this.fetchEntries();
            this.offset += this.limit;
        },
        async fetchEntries(replace = false) {
            this.loading = true;
           try {
             this.loading = true;
             const url = '/actions/simple/news/load-more?' + new URLSearchParams({
                offset: this.offset,
                category: this.category,
                sort: this.sort,
            });

            const response = await fetch(url, {
                headers: { 'Accept': 'application/json' },
            });
            const data = await response.json();

            if (replace) {
                this.$refs.results.innerHTML = data.data;
            } else {
                this.$refs.results.insertAdjacentHTML('beforeend', data.data);
            }
            this.hasMore = data.hasMore;
           } catch (error) {
            console.error('Error Load more',error);
           }finally{
               this.loading = false;
           }
        }
    }
}


document.addEventListener("alpine:init", () => {
    Alpine.data("newsApp", newsApp)
})